import breakpoints from '../../../theme/breakpoints'

import css from 'styled-jsx/css'

export default css`
  .anchors-heading {
    margin-top: 14px;
  } 

  .anchors-section {
    margin-top: 20px;
    margin-bottom: 150px;
    display: grid;
    grid-template-columns: repeat(3, minmax(227px, 1fr));
    grid-gap: 20px;
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .anchors-section {
      margin: 20px auto;
      margin-bottom: 150px;
      width: 90%;
      grid-template-columns: 1fr 1fr;
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .anchors-section {
      grid-template-columns: 1fr;
    }
  }
`
